module.exports = __webpack_public_path__ + "static/media/envelode_opened.1fdca170.png";